var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-8 cropper-wrapper"},[_c('cropper',{ref:"cropper",staticClass:"cropper-wrapper__cropper",attrs:{"src":_vm.src,"stencil-props":_vm.stencilProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }